<template>
  <div class="con-wrap">
    <div class="con-title">请联系守兔商务提供接口说明文档~</div>
    <div>
      <el-row>
        <el-col :span="6">
          <div class="img-div">
            <img src="../../../../assets/img/serverNew.jpg" alt="">
            <div class="img-tip">守兔商务</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DocumentContact',
    data() {
      return{
      }
    },
  }
</script>

<style>
  .con-wrap{
    height: auto;
    font-size: 18px;
    font-weight: bolder;
  }
  .con-wrap .con-title{
    color: #FF6600;
  }
  .con-wrap .img-div{
    text-align: center;
  }
  .con-wrap .img-div img{
    width: 100%;
    margin: 15px 0 10px 0;
  }
  .con-wrap .img-div .img-tip{
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/document/contact/index.vue